module.exports = __webpack_public_path__ + "img/romania-logo-icon.6499d063.png";